<script>
import compoment from '@/components/draggable/CustomComponents/Input/DInputEditor'
export default {
  name: 'DAccessPathEditor',
  extends: compoment
}
</script>
